<template>
  <div class="PrivacyPolicy">
      <h2>Política de Privacidade</h2>
      <p>
          É deste site respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar neste site e outros sites que possuímos e operamos.
          Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.
          Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis   para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados. Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei. O nosso site pode ter links para sites externos que não são operados por nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar responsabilidade por suas respectivas políticas de privacidade.
          Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.
          O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do usuário e informações pessoais, entre em contato conosco.
      </p>
      <br>
      <h2>Política de Cookies</h2>
      <h2>O que são cookies?</h2>
      <p>
          Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são pequenos arquivos baixados no seu computador, para melhorar sua experiência.
          Esta página descreve quais informações eles coletam, como as usamos e por que às vezes precisamos armazenar esses cookies.
          Também compartilharemos como você pode impedir que esses cookies sejam armazenados, no entanto, isso pode fazer o downgrade ou ‘quebrar’ certos elementos da
          funcionalidade do site.
      </p>
      <br>
      <h2>Como usamos os cookies?</h2>
      <p>
          Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente, na maioria dos casos, não existem opções padrão do setor para desativar os cookies sem
          desativar completamente a funcionalidade e os recursos que eles adicionam a este site. É recomendável que você deixe todos os cookies se não tiver certeza se
          precisa ou não deles, caso sejam usados   para fornecer um serviço que você usa.
      </p>
      <br>
      <h2>Desativar cookies</h2>
      <p>
          Você pode impedir a configuração de cookies ajustando as configurações do seu navegador (consulte a Ajuda do seu navegador para saber como fazer isso).
          Esteja ciente de que a desativação de cookies afetará a funcionalidade deste e de muitos outros sites que você visita. A desativação de cookies geralmente
          resultará na desativação de determinadas funcionalidades e recursos deste site. Portanto, é recomendável que você não desative os cookies.
      </p>
      <br>
      <h2>Cookies que definimos</h2>
      <h3>Cookies relacionados a pesquisas</h3>
      <p>
          Periodicamente, oferecemos pesquisas e questionários para fornecer informações interessantes, ferramentas úteis ou para entender nossa base de usuários com
          mais precisão. Essas pesquisas podem usar cookies para lembrar quem já participou numa pesquisa ou para fornecer resultados precisos após a alteração das páginas.
      </p>
      <br>
      <h3>Cookies relacionados a formulários</h3>
      <p>
          Quando você envia dados por meio de um formulário como os encontrados nas páginas de contato, os cookies podem ser configurados para lembrar os detalhes do
          usuário para correspondência futura.
      </p>
      <br>
      <h3>Cookies de preferências do site</h3>
      <p>
          Para proporcionar uma ótima experiência neste site, fornecemos a funcionalidade para definir suas preferências de como esse site é executado quando você o usa.
          Para lembrar suas preferências, precisamos definir cookies para que essas informações possam ser chamadas sempre que você interagir com uma página for afetada
          por suas preferências.
      </p>
      <br>
      <h2>Cookies de Terceiros</h2>
      <p>
          Em alguns casos especiais, também usamos cookies fornecidos por terceiros confiáveis. A seção a seguir detalha quais cookies de terceiros você pode encontrar
          através deste site.
          Este site usa o Google Analytics, que é uma das soluções de análise mais difundidas e confiáveis   da Web, para nos ajudar a entender como você usa o site e como
          podemos melhorar sua experiência. Esses cookies podem rastrear itens como quanto tempo você gasta no site e as páginas visitadas, para que possamos continuar
          produzindo conteúdo atraente. Para mais informações sobre cookies do Google Analytics, consulte a página oficial do Google Analytics.
          As análises de terceiros são usadas para rastrear e medir o uso deste site, para que possamos continuar produzindo conteúdo atrativo. Esses cookies podem rastrear
          itens como o tempo que você passa no site ou as páginas visitadas, o que nos ajuda a entender como podemos melhorar o site para você.
          Periodicamente, testamos novos recursos e fazemos alterações sutis na maneira como o site se apresenta. Quando ainda estamos testando novos recursos, esses cookies
          podem ser usados   para garantir que você receba uma experiência consistente enquanto estiver no site, enquanto entendemos quais otimizações os nossos usuários mais apreciam.
      </p>
      <br>
      <h2>Mais informações</h2>
      <p>
          Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você não tem certeza se precisa ou não, geralmente é mais seguro deixar os
          cookies ativados, caso interaja com um dos recursos que você usa em nosso site.
      </p>
      <p>Esta política é efetiva a partir de <b>Julho/2021</b>.</p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style lang="scss" scoped>
  .PrivacyPolicy {
      padding: 40px 60px;
  }
  p {
    text-align: justify;
  }
  h2 {
    margin-bottom: 20px;
  }
</style>
